import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: { title: '登录', name: '登录' },
    component: () => import(/* webpackChunkName: "Index" */ '../views/login')
  },
  {
    path: '/sign-debt',
    name: 'SignDebt',
    meta: { title: '签约合同', name: '签约合同' },
    component: () => import(/* webpackChunkName: "Index" */ '../views/sign-debt')
  },
  {
    path: '/plan',
    name: 'Plan',
    meta: { title: '方案列表', name: '方案' },
    component: () => import(/* webpackChunkName: "Index" */ '../views/plan')
  },
  {
    path: '/plan-detail',
    name: 'PlanDetail',
    meta: { title: '方案详情', name: '方案详情' },
    component: () => import(/* webpackChunkName: "Index" */ '../views/plan-detail')
  },
  {
    path: '/success',
    name: 'Success',
    meta: { title: '支付成功', name: '支付成功' },
    component: () => import(/* webpackChunkName: "Index" */ '../views/success')
  },
  {
    path: '/protocol',
    name: 'Protocol',
    meta: { title: '查看协议', name: '查看协议' },
    component: () => import(/* webpackChunkName: "Index" */ '../views/protocol')
  },
  {
    path: '*',
    redirect: '/login',
    meta: { title: '登录', name: '登录' },
    component: () => import(/* webpackChunkName: "Index" */ '../views/login')
  },
];

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})

export default router;
